import TokenService from "../admin/services/token.service";

export async function getImages() {
    let APP_URL = window.location.hostname;
    if (APP_URL.includes('www.'))
        APP_URL = APP_URL.slice(4, undefined);

    return fetch("https://api." + APP_URL + "/api/v1/promoted-images", {
        method: "GET",
        headers: {
          'Content-Type': 'application/json'
        }
    })
    .then(response => {
      if (response.status <= 300 || (response.status === 422))
          return response.json();
      else {
        return (response.json().then((res)=> {
          if (res.errors && res.errors[0].property === '*') {
            return {errors: [{property: 'misc', constraints: Object.values(res.errors[0].contraints)[0]}]};
          } else {
            return {errors: [{property: 'misc', constraints: [res.message]}]};
          }
        }))
      }
    })
    .then(jsonResponse => {
        if (jsonResponse.data) {
            return jsonResponse.data;
        //success
        } else {
            return 'Error';
        //error
        }
    })
    .catch((error) => {
        return 'Error';
    });
}

export async function startExport(startDate, endDate) {
  let APP_URL = window.location.hostname;
  if (APP_URL.includes('www.'))
      APP_URL = APP_URL.slice(4, undefined);

  return fetch("https://api." + APP_URL + "/admin/api/v1/submissions_exports", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + TokenService.getLocalAccessToken()
      },
      body: JSON.stringify({ startDate, endDate })
  })
  .then(response => {
    if (response.status <= 300 || (response.status === 422))
        return response.json();
    else {
      return (response.json().then((res)=> {
        if (res.errors && res.errors[0].property === '*') {
          return {errors: [{property: 'misc', constraints: Object.values(res.errors[0].contraints)[0]}]};
        } else {
          return {errors: [{property: 'misc', constraints: [res.message]}]};
        }
      }))
    }
  })
  .then(jsonResponse => {
      if (jsonResponse.data) {
          return jsonResponse.data;
      //success
      } else {
          return 'Error';
      //error
      }
  })
  .catch((error) => {
      return 'Error';
  });
}

export async function checkExport(id) {
  let APP_URL = window.location.hostname;
  if (APP_URL.includes('www.'))
      APP_URL = APP_URL.slice(4, undefined);

  return fetch("https://api." + APP_URL + "/admin/api/v1/queues/DefaultQueue/export-jobs/" + id, {
    method: "GET",
    headers: {
      // 'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + TokenService.getLocalAccessToken()
    }
  }).then((res) => {
    return res.json();
  }).then((res) => {
    console.log('res');
    console.log(res);
    if (res && res.data && res.data.data && res.data.data.exportResult) {
      return res.data;
    } else if (res && res.data && res.data.finishedOn) {
      return 'empty';
    } else {
      return false;
    }
  }).catch((err) => {
    return err;
  });
}


export async function submitNoteEdit(id, note) {
  let APP_URL = window.location.hostname;
  if (APP_URL.includes('www.'))
      APP_URL = APP_URL.slice(4, undefined);

  return fetch("https://api." + APP_URL + "/admin/api/v1/submissions/" + id + "/notes", {
    method: note ? "PUT" : "DELETE",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + TokenService.getLocalAccessToken(),
    },
    body: JSON.stringify({
      content: note
    })
  }).then((res) => {
    if (res.ok) return true;
    else return false;
  }).catch((err) => {
    return err;
  });
}